module.exports = __webpack_public_path__ + "aa864911f6ef7389ceb7a67d62587b2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/ch_grid_7-mobile.png
// module id = 132
// module chunks = 1